import React from "react";

const ProjectAbout = ({ projectAbout }) => {
  return (
    <section className="py-10 sm:py-14 md:py-20 px-4 sm:px-6 md:px-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto max-w-5xl">
        {/* Heading */}
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-gray-800 mb-4 sm:mb-6 text-center leading-snug">
          {projectAbout?.title || "About HPR Infra"}
        </h2>

        {/* Description */}
        <div className="space-y-3 sm:space-y-4 text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg text-center sm:text-justify">
          <p>
            {projectAbout?.subtitle ||
              "We develop plotted communities and apartments across South India with clear approvals and dependable infrastructure. Completed plots span Dabilguda in Maheshwaram, Mankhal in Adibatla and Raviriyala; apartments are delivered at Hafeezpet. A RERA registered plotted project at Kandi is ongoing."}
          </p>

          {!projectAbout?.subtitle && (
            <p>
              Layouts include blacktop roads, footpaths, curbstones, underground
              drainage with manholes, water supply from overhead tanks, street
              lighting, rainwater harvesting pits, and avenue plantation.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectAbout;
